import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { ColDef, ICellRendererParams, SelectionChangedEvent, ValueFormatterParams } from "ag-grid-community";
import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { customTheme } from "../../../../../config/theme/MuiTheme";
import AgGridCustomTable from "../../../../../util/component/AgGridCustomTable";
import { ContextOperation } from "../../../context/OperationContext";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import useToggle from "../../../hooks/useToggle";
import OperationTypes from "../../../types";
import TableDynamicActions from "../../TableDynamicActions";
import EmptyStateGrid from "../../common/EmptyStateGrid";
import { CreateDamageFormTypes } from "../Types";
import DamageFormService from "../service/DamageFormService";
import Dialogs from "./dialogs";
import PhotoGallery, { TypeImages } from "../../common/PhotoGallery";
import useSnackbar from "../../../hooks/useSnackbar";
import { useHasScope } from "../../../../../config/globalConfig";
import AgGridOperationTable from "../../common/AgGridOperationTable";

const Damages = () => {
    const t = useOperationTranslation();
    const { setLoading } = useContext(ContextOperation);
	const hasScope = useHasScope;

    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as CreateDamageFormTypes.ISharedLocationState;

    const tabs = [
        "new_damages",
        "existing_damages"
    ];
    const [selectedTab, setSelectedTab] = useState("new_damages");

    const [isOpenCreateDamage, toggleCreateDamage] = useToggle();
    const [isOpenEditDamage, toggleEditDamage] = useToggle();
    const [isOpenDeleteConfirmation, toggleDeleteConfirmation] = useToggle();
    const [isOpenDeleteFormConfirmation, toggleDeleteFormConfirmation] = useToggle();
    const [isOpenCreateEvent, toggleCreateEvent] = useToggle();
    const [isOpenAssociationConfirm, toggleAssociationConfirm] = useToggle();
    const [isOpenPhotoGallery, togglePhotoGallery] = useToggle();

    const goBack = () => {
        if (locationState?.rentalAgreement) {
            navigate("/operation/damages/forms/creation/rental-agreement", { state: locationState });
        } else {
            navigate("/operation/damages/forms/creation/general-info", { state: locationState });
        }
    }
    
    const [parts, setParts] = useState<OperationTypes.VehiclePart[]>([]);
    const [severities, setSeverities] = useState<string[]>([]);
    const [selectedDamage, setSelectedDamage] = useState<CreateDamageFormTypes.IRespCreateDamage | undefined>();
    const [events, setEvents] = useState<OperationTypes.Domain[]>([]);
    const [eventCreated, setEventCreated] = useState<CreateDamageFormTypes.IRespCreateEvent>();
    const [selectedRows, setSelectedRows] = useState<CreateDamageFormTypes.IRespCreateDamage[]>([]);
    const [isAssociateDisabled, setIsAssociateDisabled] = useState<boolean>(selectedRows.length === 0 ? true : false);
    const [isDamagesAssigned, setIsDamagesAssigned] = useState(false);
    const [photos, setPhotos] = useState<TypeImages[]>([]);

    const snackbar = useSnackbar();

    // const datasourceNewDamages: CreateDamageFormTypes.IDamages[] = [];
    const [datasourceNewDamages, setDatasourceNewDamages] = useState<CreateDamageFormTypes.IRespCreateDamage[]>([]);
    const [datasourceExistingDamages, setDatasourceExistingDamages] = useState<OperationTypes.Damage[]>([]);



    // get datasource existing damages
    useEffect(() => {

        
        DamageFormService.create.get.existingNewDamages(locationState?.generalInfo?.tenant, locationState.generalInfo?.plate)
        .then(
            response => {

                let tempNewDamages = [...datasourceNewDamages];

                for (let i = 0; i < response.length; i++) {
                    const damage : CreateDamageFormTypes.IRespCreateDamage = {
                        id: response[i]?.id,
                        partId: response[i]?.part?.id,
                        partPositionId: response[i]?.position?.id,
                        severity: response[i]?.severity,
                        vehicleId: response[i]?.vehicleId,
                        firstPhotoId: response[i]?.firstSnapshotId,
                        secondPhotoId: response[i]?.secondSnapshotId

                    }
                    //setDatasourceNewDamages([ ...datasourceNewDamages, damage ]);

                    tempNewDamages.push(damage);


                }

                setDatasourceNewDamages(tempNewDamages);

            }
        )


        DamageFormService.create.get.existingDamages(locationState?.generalInfo?.tenant, locationState.generalInfo?.plate).then(
            response => {

                let tempNewDamages = [...datasourceExistingDamages];

                for (let i = 0; i < response.length; i++) {
                    const damage : OperationTypes.Damage = {
                        id: response[i]?.id,
                        tenant: response[i]?.tenant,
                        part: response[i]?.part,
                        position: response[i]?.position,
                        damageFormId: response[i]?.damageFormId,
                        severity: response[i]?.severity,
                        damageDate: response[i]?.damageDate,
                        createDate: response[i]?.createDate,
                        updateDate: response[i]?.updateDate,
                        open: response[i]?.open,
                        label: response[i]?.label,
                        vehicleId: response[i]?.vehicleId,
                        firstSnapshotId: response[i]?.firstSnapshotId,
                        secondSnapshotId: response[i]?.secondSnapshotId,
                        newDamage: response[i]?.newDamage,
                        temporary: response[i]?.temporary

                    }
                    //setDatasourceNewDamages([ ...datasourceNewDamages, damage ]);

                    tempNewDamages.push(damage);

                }
                setDatasourceExistingDamages(tempNewDamages);
               
                
            }

        )
         
    }, []);

    // get parts & severities
    useEffect(() => {
        DamageFormService.create.get.partPosition(locationState?.generalInfo?.tenant).then(
            response => setParts(response),
        );

        DamageFormService.create.get.severity().then(
            response => setSeverities(response),
        );
    }, []);

    // get Events
    useEffect(() => {
        DamageFormService.create.get.events(locationState?.generalInfo?.tenant, undefined, 'true').then(
            response => setEvents(response),
        )
    }, []);

    // EDIT DAMAGE
    const onOpenEditDamage = (damage?: CreateDamageFormTypes.IRespCreateDamage) => {
        setSelectedDamage(damage);
        toggleEditDamage();
    }
    const onCloseEditDamage = () => {
        setSelectedDamage(undefined);
        toggleEditDamage();
    }

    // DELETE DAMAGE
    const onOpenDeleteConfirmation = (damage?: CreateDamageFormTypes.IRespCreateDamage) => {
        setSelectedDamage(damage);
        toggleDeleteConfirmation();
    }

    const onOpenDeleteFormConfirmation = () => {
        toggleDeleteFormConfirmation();
    }

    const onCloseDeleteConfirmation = () => {
        setSelectedDamage(undefined);
        toggleDeleteConfirmation();
    }
    const onCloseDeleteFormConfirmation = () => {
        toggleDeleteFormConfirmation();
    }
    const onDeleteDamage = () => {

        if (selectedDamage?.id) {

            DamageFormService.create.delete.deleteDamage(selectedDamage?.id)
            .then((response) => {

                if (!isDamagesAssigned) {
                    setDatasourceNewDamages(datasourceNewDamages.filter((damage) => damage.id !== selectedDamage?.id));
                } else {
                    setDatasourceNewDamages(datasourceNewDamages.filter((damage) => damage.id !== selectedDamage?.id));
                    setSelectedRows(selectedRows.filter((damage) => damage.id !== selectedDamage?.id))
                }

              }).catch((error: any) => {
                setLoading(false);
                snackbar.show("error", t("damageForm.damageFormCreation.message.deleteDamageErrorMessage"));
              });

        }

        
        toggleDeleteConfirmation();
    }

    // CREATE EVENT
    const onEventCreated = (event: CreateDamageFormTypes.IRespCreateEvent) => {
        setEventCreated(event);
    }

    // CLOSE PHOTO GALLERY
    const onClosePhotoGallery = () => {
        togglePhotoGallery();
        setPhotos([]);
    }

    const severityCellRenderer = (params: ICellRendererParams<CreateDamageFormTypes.IRespCreateDamage>) => {
        const color = params.data?.severity === "SOSTITUZIONE" ? "info" :
            params.data?.severity === "LIEVE" ? "success" :
            params.data?.severity === "MEDIO" ? "warning" :
            params.data?.severity === "GRAVE" ? "error" : 
            "default";
        const severity = params.data?.severity?.toLowerCase();
        return (
            <Mui.Chip
                label={t(`damageList.severityValue.${severity}` as any)}
                variant="filled"
                color={color}
            />
        )
    }

    const columnsNewDamages: ColDef[] = [
        {
            headerName: t("damageForm.damageFormCreation.damages.fields.part"),
            field: "partId",
            flex: 1,
            checkboxSelection: true,
            headerCheckboxSelection: true,            
            valueFormatter: (params: ValueFormatterParams<CreateDamageFormTypes.IRespCreateDamage>) => {
                var partCode = parts.find((part) => part.part.id === params.data?.partId && part.position.id === params.data?.partPositionId)?.part?.code || "";
                var positionCode = parts.find((part) => part.part.id === params.data?.partId && part.position.id === params.data?.partPositionId)?.position?.code || "";
                return t(`masterDataDamage.partName.${partCode}` as any)  + (positionCode != "6" ?  " " + t(`masterDataDamage.positionName.${positionCode}` as any) : "");
          }
        },
        {
            headerName: t("damageForm.damageFormCreation.damages.fields.severity"),
            field: "severity",
            flex: 1,
            cellRenderer: severityCellRenderer,
        },
        {
            headerName: "",
            field: "_actions",
            maxWidth: 100,
            cellRenderer: (params: ICellRendererParams<CreateDamageFormTypes.IRespCreateDamage>) => {
                return (
                    <TableDynamicActions moreColor={customTheme.palette.accent.main}>
                        <Mui.Tooltip
                            title={t("damageForm.damageFormCreation.button.edit")}
                            placement={"left"}
                        >
                            <Mui.Button
                                variant="text"
                                size="icon"
                                onClick={() => onOpenEditDamage(params.data)}
                            >
                                <MuiIcons.Edit />
                            </Mui.Button>
                        </Mui.Tooltip>

                        <Mui.Tooltip
                            title={t("damageForm.damageFormCreation.button.delete")}
                            placement={"left"}
                        >
                            <Mui.Button
                                variant="text"
                                size="icon"
                                onClick={() => onOpenDeleteConfirmation(params.data)}
                            >
                                <MuiIcons.Delete />
                            </Mui.Button>
                        </Mui.Tooltip>

                        <Mui.Tooltip
                            title={t("damageForm.damageFormCreation.button.images")}
                            placement={"left"}
                        >
                            <Mui.Button
                                variant="text"
                                size="icon"
                                disabled={!params.data?.firstPhotoId && !params.data?.secondPhotoId}
                                onClick={() => openPhotos(params.data)}
                            >
                                <MuiIcons.Image />
                            </Mui.Button>
                        </Mui.Tooltip>
                    </TableDynamicActions>
                )
            }
        }
    ];

    const columnsNewDamagesAssigned: ColDef[] = [
        {
            headerName: t("damageForm.damageFormCreation.damages.fields.part"),
            field: "partId",
            flex: 1,
            valueFormatter: (params: ValueFormatterParams<CreateDamageFormTypes.IRespCreateDamage>) => {
                var partName = parts.find((part) => part.part.id === params.data?.partId && part.position.id === params.data?.partPositionId)?.part?.code || "";
                if (partName === "") return "";
                //partName = partName.replaceAll(" ", '_');
                return t(`masterDataDamage.partName.${partName}` as any);
            }
        },
        {
            headerName: t("damageForm.damageFormCreation.damages.fields.severity"),
            field: "severity",
            flex: 1,
            cellRenderer: severityCellRenderer,
        },
        {
            headerName: "",
            field: "_actions",
            maxWidth: 100,
            cellRenderer: (params: ICellRendererParams<CreateDamageFormTypes.IRespCreateDamage>) => {
                return (
                    <TableDynamicActions moreColor={customTheme.palette.accent.main}>
                        <Mui.Tooltip
                            title={t("damageForm.damageFormCreation.button.images")}
                            placement={"left"}
                        >
                            <Mui.Button
                                variant="text"
                                size="icon"
                                onClick={() => openPhotos(params.data)}
                            >
                                <MuiIcons.Image />
                            </Mui.Button>
                        </Mui.Tooltip>

                        <Mui.Tooltip
                            title={t("damageForm.damageFormCreation.button.delete")}
                            placement={"left"}
                        >
                            <Mui.Button
                                variant="text"
                                size="icon"
                                onClick={() => onOpenDeleteConfirmation(params.data)}
                            >
                                <MuiIcons.Delete />
                            </Mui.Button>
                        </Mui.Tooltip>
                    </TableDynamicActions>
                )
            }
        }
    ];

    const columnsExistingDamages: ColDef[] = [
        {
            headerName:  t("damageForm.damageFormCreation.damages.fields.part"),
            field: "part",
            flex: 1,
            valueFormatter: (params: ValueFormatterParams<OperationTypes.Damage>) => {
                var partName = parts.find((part) => part.part.id === params.data?.part?.id && part.position.id === params.data?.position?.id)?.part?.code || "";
                if (partName === "") return "";
                //partName = partName.replaceAll(" ", '_');
                return t(`masterDataDamage.partName.${partName}` as any);
            }
        },
        {
            headerName:  t("damageForm.damageFormCreation.damages.fields.severity"),
            field: "severity",
            flex: 1,
            cellRenderer: severityCellRenderer,
        },
        {
            headerName: "",
            field: "_actions",
            maxWidth: 70,
            cellRenderer: (params: ICellRendererParams<OperationTypes.Damage>) => {
                return (
                    <TableDynamicActions moreColor={customTheme.palette.accent.main}>
                        <Mui.Tooltip
                            title={t("damageForm.damageFormCreation.button.images")}
                            placement={"left"}
                        >
                            <Mui.Button
                                variant="text"
                                size="icon"
                                disabled={!params.data?.firstSnapshotId && !params.data?.secondSnapshotId}
                                onClick={() => openSnapshot(params.data)}
                            >
                                <MuiIcons.Image />
                            </Mui.Button>
                        </Mui.Tooltip>
                    </TableDynamicActions>
                )
            }
        }
    ]

    const openPhotos = (damage?: CreateDamageFormTypes.IRespCreateDamage) => {
        if (!damage) return;

        setLoading(true);
        DamageFormService.create.get.photos(damage.id.toString()).then(
            response => {
                if (response.length == 1) {
                    Promise.all([
                        DamageFormService.create.get.photoBlob(response[0].id.toString()),
                    ]).then(
                        response => {
                            setPhotos(response.map((res) => ({ base64: res })));
                            setLoading(false);
                            togglePhotoGallery();
                        }
                    )
                } else if (response.length >= 2) {
                    Promise.all([
                        DamageFormService.create.get.photoBlob(response[0].id.toString()),
                        DamageFormService.create.get.photoBlob(response[1].id.toString()),
                    ]).then(
                        response => {
                            setPhotos(response.map((res) => ({ base64: res })));
                            setLoading(false);
                            togglePhotoGallery();
                        }
                    )
                }
            },
            error => {
                setLoading(false);
            }
        )
    }

    const openSnapshot = (damage?: OperationTypes.Damage) => {
        if (!damage) return;

        setLoading(true);
        DamageFormService.create.get.photos(damage.id.toString()).then(
            response => {
                if (response.length == 1) {
                    Promise.all([
                        DamageFormService.create.get.photoBlob(response[0].id.toString()),
                    ]).then(
                        response => {
                            setPhotos(response.map((res) => ({ base64: res })));
                            setLoading(false);
                            togglePhotoGallery();
                        }
                    )
                } else if (response.length >= 2) {
                    Promise.all([
                        DamageFormService.create.get.photoBlob(response[0].id.toString()),
                        DamageFormService.create.get.photoBlob(response[1].id.toString()),
                    ]).then(
                        response => {
                            setPhotos(response.map((res) => ({ base64: res })));
                            setLoading(false);
                            togglePhotoGallery();
                        }
                    )
                }
            },
            error => {
                setLoading(false);
            }
        )
    }

    const onCreateDamage = (damage: CreateDamageFormTypes.IRespCreateDamage) => {

        if (!isDamagesAssigned) {
            setDatasourceNewDamages([ ...datasourceNewDamages, damage ]);
        } else {
            setDatasourceNewDamages([ ...datasourceNewDamages, damage ]);
            setSelectedRows([ ...selectedRows, damage ]);

            let tempSelectedRows = [...selectedRows];
            let tempNewdamages = [...datasourceNewDamages];

            tempSelectedRows.push(damage);
            tempNewdamages.push(damage);

            const data: CreateDamageFormTypes.IReqAssignDamage = {
                damageIdList: tempSelectedRows.map((damage) => damage.id),
                formId: eventCreated!.id,
            }

            assignDamage(data);

            
            setDatasourceNewDamages(tempNewdamages);
            setSelectedRows(tempSelectedRows);
        }
    }

    const onSelctionChanged = (event: SelectionChangedEvent<CreateDamageFormTypes.IRespCreateDamage>) => {
        const selectedRows = event?.api.getSelectedRows();
        if (!selectedRows || selectedRows.length === 0) {
            setIsAssociateDisabled(true);
        } else {
            setIsAssociateDisabled(false);
        }

        setSelectedRows(selectedRows);
    }

    const assignDamage = (data: CreateDamageFormTypes.IReqAssignDamage, callBack?: () => void) => {
        
        setLoading(true);
        DamageFormService.create.post.assignDamage(locationState?.generalInfo?.tenant, true, [data]).then(
            response => {

                setIsDamagesAssigned(true);
                setLoading(false);
                callBack && callBack();
            },
            error => {
                setLoading(false);
                if (error.response.status == 409) {
                    snackbar.show("error", t("damageList.damageCreation.message.409errorDamagesCreation"));
                } else {
                    snackbar.show("error", t("damageList.damageCreation.message.errorDamagesCreation"));
                }
                callBack && callBack();
            }
        )
    }

    const onAssignConfirm = () => {
        if (!eventCreated?.id) {
            return;
        }

        const data: CreateDamageFormTypes.IReqAssignDamage = {
            damageIdList: selectedRows.map((damage) => damage.id),
            formId: eventCreated?.id,
        }

        assignDamage(data, toggleAssociationConfirm);
    }

    const onDeleteEvent = () => {

        if (eventCreated) {

            DamageFormService.create.delete.deleteForm(eventCreated?.id)
            .then((response) => {

                setEventCreated(undefined);
                setIsDamagesAssigned(false);
                

            }).catch((error: any) => {
                setLoading(false);
                snackbar.show("error", t("damageForm.damageFormCreation.message.deleteDamageFormErrorMessage"));
            });
        }  
        
        toggleDeleteFormConfirmation();
    }

    const onFormConfirmation = () => {
        const data: CreateDamageFormTypes.IReqConfirmCreation = {
            formDataList: [
                {
                    formId: eventCreated!.id,
                    eventDate: locationState.generalInfo?.eventDate,
                    eventCity: locationState.generalInfo?.eventCity,

                }
            ]
        }

        setLoading(true);
        DamageFormService.create.post.confirmCreation(locationState?.generalInfo?.tenant, locationState.generalInfo?.formManagementSapId, data).then(
            response => {
                navigate(`/operation/damages/forms/details/${eventCreated?.id}`);
                setLoading(false);
            },
            error => {
                setLoading(false);
            }
        )
    }

    const availableParts = useMemo(() => {
        if (!isDamagesAssigned) {
            return parts.filter((part) => 
                !datasourceNewDamages.find((damage) => damage.partId === part.part.id && damage.partPositionId === part.position.id)
            );
        } else {
            return parts.filter((part) => 
                !selectedRows.find((damage) => damage.partId === part.part.id && damage.partPositionId === part.position.id)
            );
        }
    }, [parts, isDamagesAssigned, datasourceNewDamages]);
    

    const isCreateFormDisabled = useMemo(() => {
        if (!eventCreated) {
            return true;
        }

        if (eventCreated && datasourceNewDamages.length === 0 && hasScope("SCOPE_CREATE_DAMAGE_DAMAGE_FORM_NO_DAMAGE")) {
            return false;
        }

        if (eventCreated && datasourceNewDamages.length > 0 && isDamagesAssigned) {
            return false;
        }

        return true;
    }, [eventCreated, datasourceNewDamages, isDamagesAssigned]);

    return(
        <>
            <Mui.Card>
                <Mui.Box component={"div"}>
                    <Mui.Tabs
                        value={selectedTab}
                        onChange={(_event, value) => setSelectedTab(value)}
                    >
                        <Mui.Tab
                            label={
                                <div>
                                    <Mui.Typography fontWeight="bold">
                                        {t("damageForm.damageFormCreation.damages.tab1Card")}
                                    </Mui.Typography>
                                </div>
                            }
                            value={tabs[0]}
                        ></Mui.Tab>
                        <Mui.Tab
                            label={
                                <div>
                                    <Mui.Typography fontWeight="bold">
                                        {t("damageForm.damageFormCreation.damages.tab2Card")}
                                    </Mui.Typography>
                                </div>
                            }
                            value={tabs[1]}
                        ></Mui.Tab>
                    </Mui.Tabs>
                </Mui.Box>
                    
                <Mui.CardContent>
                    {selectedTab === tabs[0] && (
                        <Mui.Box>
                            {!isDamagesAssigned && (
                                <>
                                    <Mui.Grid container mb="10px">
                                        {eventCreated && (
                                            <Mui.Grid item xs="auto" ml="auto">
                                                <Mui.Button
                                                    variant="outlined"
                                                    onClick={toggleAssociationConfirm}
                                                    disabled={isAssociateDisabled}
                                                >
                                                    <Mui.Typography
                                                        color={"accent"}
                                                        fontWeight={700}
                                                        fontSize={"13px"}
                                                    >
                                                        {t("damageForm.damageFormCreation.button.associate")}
                                                    </Mui.Typography>
                                                </Mui.Button>
                                            </Mui.Grid>
                                        )}

                                        <Mui.Grid item xs="auto" ml={eventCreated ? "5px" : "auto"}>
                                            <Mui.Button
                                                variant="contained"
                                                onClick={toggleCreateEvent}
                                                disabled={eventCreated ? true : false}
                                            >
                                                <Mui.Typography
                                                    color={"accent"}
                                                    fontWeight={700}
                                                    fontSize={"13px"}
                                                >
                                                    {t("damageForm.damageFormCreation.button.createEvent")}
                                                </Mui.Typography>
                                            </Mui.Button>
                                        </Mui.Grid>

                                        <Mui.Grid item xs="auto" ml="5px" mr="5px">
                                            <Mui.Button
                                                variant="text"
                                                size="icon"
                                                onClick={toggleCreateDamage}
                                            >
                                                <MuiIcons.Add />
                                            </Mui.Button>
                                        </Mui.Grid>        
                                    </Mui.Grid>

                                    <AgGridOperationTable
                                        rowData={datasourceNewDamages}
                                        columnDefs={columnsNewDamages}
                                        rowSelection="multiple"
                                        onSelectionChanged={onSelctionChanged}
                                        totalElements={datasourceNewDamages.length}
										rowModelType="clientSide"
                                        emptyState={{
                                            title: t("damageForm.damageFormCreation.damages.emptyState.title"),
                                            content: t("damageForm.damageFormCreation.damages.emptyState.content1")
                                        }}

                                        />
                                </>
                            )}

                            {isDamagesAssigned && (
                                <Mui.Card>
                                    <Mui.CardContent>
                                        <Mui.Stack
                                            direction="row"
                                            marginY="5px"
                                            padding="10px"
                                            borderRadius="4px"
                                            style={{
                                                backgroundColor: customTheme.palette.primary.main,
                                            }}
                                            justifyContent="center"
                                        >
                                            <Mui.Typography color={customTheme.palette.common.white}>
                                                {t("damageForm.damageFormCreation.damages.fields.titleCard")} {eventCreated?.id}
                                            </Mui.Typography>

                                            <Mui.Box ml="auto">
                                                <Mui.Tooltip title={t("damageForm.damageFormCreation.button.deleteEvent")}>
                                                    <Mui.Button
                                                        variant="text"
                                                        size="icon"
                                                        onClick={() => onOpenDeleteFormConfirmation()}
                                                    >
                                                        <MuiIcons.Delete style={{ color: customTheme.palette.common.white }} />
                                                    </Mui.Button>
                                                </Mui.Tooltip>
                                            </Mui.Box>
                                        </Mui.Stack>

                                        <Mui.Stack direction="row" marginY="5px" padding="10px">
                                            <Mui.Typography>
                                                {events.find(ev => ev.id === eventCreated?.eventId)?.descr}
                                            </Mui.Typography>

                                            <Mui.Box ml="auto">
                                                <Mui.Tooltip title={t("damageForm.damageFormCreation.button.addDamage")}>
                                                    <Mui.Button
                                                        variant="text"
                                                        size="icon"
                                                        onClick={toggleCreateDamage}
                                                    >
                                                        <MuiIcons.Add />
                                                    </Mui.Button>
                                                </Mui.Tooltip>
                                            </Mui.Box>
                                        </Mui.Stack>
                                        
                                        <AgGridOperationTable
                                            rowData={selectedRows}
                                            columnDefs={columnsNewDamagesAssigned}
                                            totalElements={datasourceNewDamages.length}
											rowModelType="clientSide"
                                            emptyState={{
                                                title: t("damageForm.damageFormCreation.damages.emptyState.title"),
                                                content: t("damageForm.damageFormCreation.damages.emptyState.content1")
                                            }}
                                        />

                                    </Mui.CardContent>
                                </Mui.Card>
                            )}
                        </Mui.Box>
                    )}

                    {selectedTab === tabs[1] && (
                        <Mui.Box>
                            <AgGridOperationTable
                                columnDefs={columnsExistingDamages}
                                rowData={datasourceExistingDamages}
								rowModelType="clientSide"
                                emptyState={{
                                    title: t("damageForm.damageFormCreation.damages.emptyState.title"),
                                    content: t("damageForm.damageFormCreation.damages.emptyState.content1")
                                }}
                            />

                        </Mui.Box>
                    )}
                </Mui.CardContent>
                
                <Mui.CardActions>
                    <Mui.Grid container spacing={2} justifyContent="end">
                        <Mui.Grid item xs={12} md={"auto"}>
                            <Mui.Button 
                                variant="outlined" 
                                fullWidth 
                                size="medium"
                                onClick={goBack}
                            >
                                <Mui.Typography color={customTheme.palette.accent.main}>
                                    {t("damageForm.damageFormCreation.button.back")} 
                                </Mui.Typography>
                            </Mui.Button>
                        </Mui.Grid>

                        <Mui.Grid item xs={12} md={"auto"}>
                            <Mui.Button 
                                variant="contained"
                                fullWidth 
                                type="submit" 
                                onClick={onFormConfirmation}
                                size="medium"
                                disabled={isCreateFormDisabled}
                            >
                                <Mui.Typography variant="h6" color={'accent'}>
                                    {t("damageForm.damageFormCreation.button.createForm")} 
                                </Mui.Typography>
                            </Mui.Button>
                        </Mui.Grid>
                    </Mui.Grid>
                </Mui.CardActions>
            </Mui.Card>

            <Dialogs.CreateDamage
                open={isOpenCreateDamage}
                onClose={toggleCreateDamage}
                onCreateDamage={onCreateDamage}
                parts={availableParts}
                severities={severities}
            />

            <Dialogs.EditDamage
                open={isOpenEditDamage}
                onClose={onCloseEditDamage}
                parts={parts}
                severities={severities}
                damage={selectedDamage}
            />

            <Dialogs.DeleteConfirmation
                isOpen={isOpenDeleteConfirmation}
                onClose={onCloseDeleteConfirmation}
                parts={parts}
                damage={selectedDamage}
                onDelete={onDeleteDamage}
            />

        <Dialogs.DeleteFormConfirmation
                isOpen={isOpenDeleteFormConfirmation}
                onClose={onCloseDeleteFormConfirmation}
                formId={eventCreated?.id}
                onDelete={onDeleteEvent}
            />

            <Dialogs.CreateEvent
                isOpen={isOpenCreateEvent}
                onClose={toggleCreateEvent}
                onEventCreated={onEventCreated}
                events={events}
            />

            <Dialogs.AssociationConfirmation 
                isOpen={isOpenAssociationConfirm}
                onClose={toggleAssociationConfirm}
                onAssignConfirm={onAssignConfirm}
            />

            <PhotoGallery
                images={photos}
                onClose={onClosePhotoGallery}
                open={isOpenPhotoGallery}
            />
        </>
    )
};
export default Damages